module.exports = __webpack_public_path__ + "img/公司背景.190f9062.png";